import { secureFetch } from "./secureFetch";

const DONOR_TOKEN_KEY = "pg_donor_token";

export const getDonorToken = () => {
  try {
    return localStorage.getItem(DONOR_TOKEN_KEY) || "";
  } catch {
    return "";
  }
};

export const setDonorToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(DONOR_TOKEN_KEY, token);
    }
  } catch {}
};

export const clearDonorToken = () => {
  try {
    localStorage.removeItem(DONOR_TOKEN_KEY);
  } catch {}
};

export const donorSecureFetch = async (path, options = {}) => {
  const token = getDonorToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  return secureFetch(path, { ...options, headers, includeFirebaseAuth: false });
};
